<template>
    <el-form :model="form" ref="form" label-width="100px">
        <el-form-item prop="" label="选择分类:">
            <div class="ctc-select-container">
                <el-select @click.native="loadCate" @change="loadSecond" v-model="form.cate" placeholder="请选择"
                    style="width: 100%" clearable filterable size="mini">
                    <el-option v-for="item in cateOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <div> - </div>
                <el-select v-model="form.second" placeholder="请选择" @change="$emit('handleChange',form.second)" style="width: 100%" clearable filterable size="mini">
                    <el-option v-for="item in secondOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: 'CallTaskCate',
    data() {
        return {
            form: {
                cate: '',
                second: ''
            },
            cateOptions: [],
            secondOptions: []
        }
    },
    methods: {
        loadCate() {
            this.$axios.get('api/api3_call_task/load_first_level',{ loadingClose: true }).then(({ data }) => {
                if (data.code === 0) {
                    this.cateOptions = data.data
                }
            }).catch()
        },
        loadSecond(id) {
            this.$axios.get('api/api3_call_task/load_second_level', {
                loadingClose: true,
                params: {
                    id
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.secondOptions = data.data
                }
            }).catch()
        },
    }
}
</script>

<style scoped>
.ctc-select-container {
    display: flex;
    gap: 8px;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/CallTaskCate.vue